import { Control } from '../../../../vas/business-objects/control/control.model';
import { CONTROL_TYPES } from '../../../../vas/controls/control-types';
import * as actions from '../form-manager-page.actions';
import { initialState, State } from '../form-manager-page.reducer';

export const controlFormLoadReducer = (
    state = initialState,
    action: actions.ControlFormLoad
): State => {
    return {
        ...state,
        controlForm: {
            control: action.payload.controlId ?
                state.control.entities[action.payload.controlId] :
                new Control({
                    account: action.payload.accountId,
                    controlType: state.controlType.ids
                        .map(id => state.controlType.entities[id])
                        .find(ct => ct.name === CONTROL_TYPES.TEXT)
                        .id,
                    group: state.group.selected,
                    accessGroup: (() => {

                        if (state.accessGroups.ids.length > 1) {
                            return undefined;
                        }

                        return state.accessGroups
                            .entities[state.accessGroups.ids[0]].id;
                    })()
                })
        }
    };
};



// WEBPACK FOOTER //
// ./src/app/pages/form-manager-page/reducers/control-form-load.reducer.ts